import { IAccountListTableLang } from '../../../types/lang'

export const accountListTableLang: IAccountListTableLang = {
	account_list_table: {
		column_id: 'ID_ua',
		column_email: 'Email_ua',
		column_login: 'Login_ua',
		column_kt_group: 'KT Group_ua',
		column_role: 'Role_ua',
		column_is_buyer: 'Buyer_ua',
		column_in_group: 'Group_ua',
		column_is_team: 'Team_ua',
		column_is_active: 'Active_ua',
		column_is_fired: 'Fired_ua',
		column_date_registered: 'Date Registered_ua',
		column_date_deleted: 'Date Deleted_ua',
	}
}